var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmptyStarLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3063 10.8168C20.8396 6.27225 22.1063 4 24 4C25.8937 4 27.1604 6.27225 29.6937 10.8167L30.3491 11.9925C31.069 13.2839 31.4289 13.9296 31.9901 14.3556C32.5513 14.7817 33.2503 14.9398 34.6482 15.2561L35.9209 15.5441C40.8403 16.6571 43.3 17.2136 43.8852 19.0955C44.4704 20.9773 42.7935 22.9381 39.4398 26.8598L38.5722 27.8744C37.6191 28.9889 37.1426 29.5461 36.9283 30.2354C36.7139 30.9248 36.7859 31.6682 36.93 33.1551L37.0612 34.5088C37.5682 39.7412 37.8218 42.3574 36.2897 43.5204C34.7576 44.6835 32.4547 43.6231 27.8487 41.5023L26.657 40.9537C25.3481 40.351 24.6937 40.0497 24 40.0497C23.3063 40.0497 22.6519 40.351 21.343 40.9537L20.1513 41.5023C15.5454 43.6231 13.2424 44.6835 11.7103 43.5204C10.1782 42.3574 10.4318 39.7412 10.9388 34.5088L11.07 33.1551C11.2141 31.6682 11.2861 30.9248 11.0717 30.2354C10.8574 29.5461 10.3809 28.9889 9.42784 27.8744L8.56019 26.8599C5.2065 22.9381 3.52965 20.9773 4.11484 19.0955C4.70003 17.2136 7.15971 16.6571 12.0791 15.5441L13.3518 15.2561C14.7497 14.9398 15.4487 14.7817 16.0099 14.3556C16.5711 13.9296 16.9311 13.2839 17.6509 11.9925L18.3063 10.8168Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyStarLarge);
export default __webpack_public_path__ + "static/media/ic_empty_star_large.cb29a26d844ee1de6b50e75ed07f1075.svg";
export { ForwardRef as ReactComponent };